import "./Services.scss";
import { useRef } from "react";
import { useInView, motion } from "framer-motion";
import backgroundImage from "../../Assets/images/img2.jpg";
import img1 from "../../Assets/images/servicesimg/coveredhall.png";
import img2 from "../../Assets/images/servicesimg/stadium.jpg";
import img3 from "../../Assets/images/servicesimg/commercialstructure.jpg";
import img4 from "../../Assets/images/servicesimg/residentialstructure.png";
import img5 from "../../Assets/images/servicesimg/publicbuilding.jpg";
import img6 from "../../Assets/images/servicesimg/landscaping.jpg";
import img7 from "../../Assets/images/servicesimg/geotechnicaldesign.jpg";
import img8 from "../../Assets/images/servicesimg/urbanplanning.jpeg";
import img9 from "../../Assets/images/servicesimg/transportation.jpeg";
import img10 from "../../Assets/images/servicesimg/watersupply.jpeg";
import img11 from "../../Assets/images/servicesimg/electricalworks.jpeg";
import img12 from "../../Assets/images/servicesimg/sewage.jpeg";
import img13 from "../../Assets/images/servicesimg/irrigation.jpeg";
import img14 from "../../Assets/images/servicesimg/remotesensing.jpeg";
import img15 from "../../Assets/images/servicesimg/valuation.jpeg";
import img16 from "../../Assets/images/servicesimg/Feasibilitystudy.webp";
import img17 from "../../Assets/images/servicesimg/rivertraining.jpg";
import img18 from "../../Assets/images/servicesimg/softwaretraining.jpeg";

const Services = () => {
  const titleRef = useRef(null);
  const isInView = useInView(titleRef, {
    once: true,
    amount: 0.1,
  });

  const services = [
    {
      title: "Multi-purpose covered hall",
      description:
        "We create versatile covered halls with global safety standards and innovative functionality.",
      icon: "🏢",
      image: img1,
    },
    {
      title: "Stadium",
      description:
        "Cutting-edge designs for stadiums, prioritizing spectator experience, safety, and modern amenities.",
      icon: "📊",
      image: img2,
    },
    {
      title: "Commercial Structures",
      description:
        "Efficient and modern designs for offices, retail, and industrial spaces.",
      icon: "💰",
      image: img3,
    },
    {
      title: "Residential Structures",
      description:
        "Tailored designs for comfortable and aesthetic homes, apartments, and communities.",
      icon: "🏗️",
      image: img4,
    },
    {
      title: "Public Buildings",
      description:
        "Expert designs for schools, libraries, and community centers, emphasizing accessibility and sustainability.",
      icon: "🏛️",
      image: img5,
    },
    {
      title: "Landscaping",
      description:
        "Comprehensive designs transforming outdoor spaces into visually appealing environments.",
      icon: "📣",
      image: img6,
    },
    {
      title: "Geotechnical/ Geological Design",
      description:
        "Specialized designs focused on soil, rock, and groundwater conditions for safe and efficient construction.",
      icon: "📣",
      image: img7,
    },
    {
      title: "Urban Planning",
      description:
        "Strategic planning for sustainable urban growth, infrastructure integration, and community well-being.",
      icon: "📣",
      image: img8,
    },
    {
      title: "Transportation",
      description:
        "Efficient and safe transport system designs including roads and transit hubs to enhance mobility.",
      icon: "📣",
      image: img9,
    },
    {
      title: "Water Supply & Sanitary Design",
      description:
        "Reliable and sustainable designs for clean water distribution and effective wastewater management.",
      icon: "📣",
      image: img10,
    },
    {
      title: "Electrical Works",
      description:
        "Comprehensive electrical system designs ensuring safety, energy efficiency, and future scalability.",
      icon: "📣",
      image: img11,
    },
    {
      title: "Sewerage & Land-fill Site Design",
      description:
        "Environmentally sound solutions for sewer networks and landfill sites with regulatory compliance.",
      icon: "📣",
      image: img12,
    },
    {
      title: "Irrigation",
      description:
        "Smart irrigation system designs enhancing agricultural productivity and water conservation.",
      icon: "📣",
      image: img13,
    },
    {
      title: "Remote Sensing based survey and mapping",
      description:
        "Accurate data capture using satellite and drone technology for mapping and spatial analysis.",
      icon: "📣",
      image: img14,
    },
    {
      title: "Valuation",
      description:
        "Professional valuation services for real estate, assets, and infrastructure based on industry standards.",
      icon: "📣",
      image: img15,
    },
    {
      title: "Feasibility Study",
      description:
        "In-depth assessments evaluating the technical, financial, and environmental viability of projects.",
      icon: "📣",
      image: img16,
    },
    {
      title: "River-training works",
      description:
        "Engineered solutions to control river flow, prevent erosion, and protect nearby developments.",
      icon: "📣",
      image: img17,
    },
    {
      title: "Software trainings",
      description:
        "Hands-on training programs on industry-relevant software tools for engineers and planners.",
      icon: "📣",
      image: img18,
    },
  ];

  return (
    <section className="services-section">
      <div
        className="services-banner"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="services-overlay" />
        <div className="services-text container text-left">
          <motion.div
            ref={titleRef}
            initial={{ opacity: 0, y: 100 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          >
            <h5>SERVICES</h5>
          </motion.div>
        </div>
      </div>

      <div className="white-container">
        <div className="inner-container"></div>
      </div>

      <div className="services-title">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h4>
            Delivering excellence <br /> across these domains
          </h4>
        </motion.div>
      </div>

      <div className="services-grid container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div
              className="hover-image"
              style={{ backgroundImage: `url(${service.image})` }}
            >
              <div className="hover-overlay"></div>
            </div>
            <div className="service-content">
              <div className="service-number">{`${index + 1}.`}</div>
              {/* <div className="service-icon">{service.icon}</div> */}
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
            <div class="service-wave">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="320"
                height="104"
                viewBox="0 0 320 104"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 0H320C290.545 0 267.772 24.6753 253.628 49.8666C235.516 82.1247 200.378 104 160 104C119.622 104 84.4835 82.1247 66.3718 49.8666C52.228 24.6753 29.4552 0 0 0Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
